import React from 'react';
import ColorPicker from './ColorPicker';

const SocialIconsCustomization = ({ formData, updateFormData }) => {
  return (
    <div className="form-section-content">
      <h3 className="section-title">Icônes des réseaux sociaux</h3>
      
      {/* Slider Taille */}
      <div className="form-group">
        <label className="form-label" htmlFor="iconSize">
          Taille: {formData.iconSize}px
        </label>
        <input
          type="range"
          id="iconSize"
          className="form-range"
          min="16"
          max="40"
          value={formData.iconSize}
          onChange={(e) => updateFormData('iconSize', parseInt(e.target.value))}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: 'var(--text-light)', marginTop: '5px' }}>
          <span>16px</span>
          <span>40px</span>
        </div>
      </div>
      
      {/* Select Forme */}
      <div className="form-group">
        <label className="form-label" htmlFor="iconShape">Forme</label>
        <select
          id="iconShape"
          className="form-select"
          value={formData.iconShape}
          onChange={(e) => updateFormData('iconShape', e.target.value)}
        >
          <option value="rond">Rond</option>
          <option value="carré">Carré</option>
        </select>
      </div>
      
      {/* ColorPicker Arrière-plan de l'icône */}
      <div style={{ width: '50%' }}>
        <ColorPicker
          label="Arrière-plan de l'icône"
          value={formData.iconBackgroundColor}
          onChange={(value) => updateFormData('iconBackgroundColor', value)}
          placeholder="transparent"
        />
      </div>
    </div>
  );
};

export default SocialIconsCustomization;